import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';

const getSubscriptionDetails = async ({ subReference, clientId, lang }) => {
  let subDetails = {};

  try {
    const data = await getData(
      `${URLS.QUOTE_CLIENTS_V2}/${clientId}/subscriptions/${subReference}`
    );
    subDetails = data;
  } catch {}
  return subDetails;
};

export default getSubscriptionDetails;
